<script lang="ts">
    import { apiBaseURL } from "../../config"

    export let appointment: Appointment

    const getDate = () => {
        const from = appointment?.date ? new Date(appointment?.date) : null
        const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        }
        // @ts-ignore
        return from.toLocaleDateString("de-DE", options)
    }
</script>

<div class="appointment">
    {#if appointment?.date}
        {getDate()}
    {/if}
</div>
